// extracted by mini-css-extract-plugin
export default {"conversation-container":"conversation-container--mp-q3uwM","conversationContainer":"conversation-container--mp-q3uwM"};